/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsTriangleExclamationEmpty: {
  name: 'triangle-exclamation-empty';
  data: string;
} = {
  name: 'triangle-exclamation-empty',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><g clip-path="url(#a)"><path fill-rule="evenodd" clip-rule="evenodd" d="M8 .5a.5.5 0 0 1 .447.276l7 14A.5.5 0 0 1 15 15.5H1a.5.5 0 0 1-.447-.724l7-14A.5.5 0 0 1 8 .5Zm6.191 14L8 2.118 1.809 14.5h12.382ZM8 5a.5.5 0 0 1 .5.5v5a.5.5 0 0 1-1 0v-5A.5.5 0 0 1 8 5Zm0 8a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1Z" fill="currentColor"/></g><defs><clipPath id="a"><path fill="currentColor" d="M0 0h16v16H0z"/></clipPath></defs></svg>`,
};
